module.exports = __webpack_public_path__ + "img/turkey.38c7bf8d.svg";